<template>
  <div>
      <field
              :title="$t('wall.central-power-supply.title')"
              :description="$t('wall.central-power-supply.description')"
              :help="$t('wall.central-power-supply.help')"
              class="mt-6">
          <chooser v-model="wall.central_power_supply"></chooser>
      </field>
      <simple-hint v-if="wall.hasCentralPowerSupply()" class="mt-2 -mx-4">
          {{ $t('wall.central-power-supply.hint') }}
      </simple-hint>
      <div v-else-if="wall.hasNoCentralPowerSupply()">
          <field
                  :title="$t('wall.use-plug.title')"
                  :description="$t('wall.use-plug.description')" class="mt-6">
              <chooser v-model="wall.useplug"></chooser>
          </field>
      </div>

      <!-- Light color -->
      <!--                <field-->
      <!--                    :title="$t('wall.light-color.title')"-->
      <!--                    :description="$t('wall.light-color.description')" class="mt-6">-->
      <!--                    <chooser v-model="wall.color" :options="options.colors"></chooser>-->
      <!--                </field>-->

      <!-- Dimmable -->
      <!--                <field-->
      <!--                    :title="$t('wall.dimmable.title')"-->
      <!--                    :description="$t('wall.dimmable.description')" class="mt-6">-->
      <!--                    <chooser v-model="wall.dimmable"></chooser>-->
      <!--                </field>-->
      <!--            <div v-if="wall.isStatic()">-->
      <field
              :title="$t('wall.remote.title')"
              :description="$t('wall.remote.description')" class="mt-6">
          <chooser v-model="wall.funkschalter"></chooser>
      </field>
      <!--            </div>-->
      <field
              :title="$t('wall.smarthome.title')"
              :description="$t('wall.smarthome.description')"
              :help="$t('wall.smarthome.help')" class="mt-6">
          <chooser v-model="wall.smart"></chooser>
      </field>
      <div v-if="wall.hasSmarthomeIntegration()">
          <field
                  :title="$t('wall.existing-smarthome.title')"
                  :description="$t('wall.existing-smarthome.description')" class="mt-6">
              <input v-model="wall.existing_smarthome">
          </field>
      </div>
  </div>
</template>

<script>
export default {
    props: {
        wall: {
            type: Object
        }
    }
}
</script>